import {
  SET_ACMG_PILLS_TOGGLE_STATE,
  SET_ACMG_ACTIVE_OVERRIDES_STRENGTH_STATE,
  SET_ACMG_PILLS_TO_DEFAULT,
  SET_ACMG_ACTIVE_OVERRIDES_STRENGTH_TO_DEFAULT,
  SET_LAST_USED_VARIANTID,
  SET_CLINICAL_EVIDENCE_STATE,
} from "./actionTypes";

const setAcmgToggleStateAction = (params) => {
  return {
    type: SET_ACMG_PILLS_TOGGLE_STATE,
    params,
  };
};

const setLastUsedVariantIdAction = (params) => {
  return {
    type: SET_LAST_USED_VARIANTID,
    params,
  };
};

const setClinicalEvidenceStateAction = (params) => {
  return {
    type: SET_CLINICAL_EVIDENCE_STATE,
    params,
  };
};

const setAcmgActiveOverridesStrengthAction = (params) => {
  return {
    type: SET_ACMG_ACTIVE_OVERRIDES_STRENGTH_STATE,
    params,
  };
};

const setAcmgToggleToDefaultAction = () => {
  return {
    type: SET_ACMG_PILLS_TO_DEFAULT,
  };
};

const setAcmgActiveOverridesToDefaultAction = () => {
  return {
    type: SET_ACMG_ACTIVE_OVERRIDES_STRENGTH_TO_DEFAULT,
  };
};

export {
  setClinicalEvidenceStateAction,
  setAcmgToggleStateAction,
  setAcmgActiveOverridesStrengthAction,
  setAcmgToggleToDefaultAction,
  setAcmgActiveOverridesToDefaultAction,
  setLastUsedVariantIdAction,
};
